import React from 'react';
import AnswerButton from '../Buttons/AnswerButton';
import Text from '../Text';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App
 *
 * Step B
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepKategorie = props => {
  return (<>
    <h2 className="headline headline--2">Was trifft zu?</h2>

    <div className="text text--afp-quickcheck">
      <Text path="steps.kategorie.text">Ich bin / Wir sind...</Text>
    </div>

    <div className="container__afp-quickcheck-answers">
      <AnswerButton journey={'schuelerGruppe'}>Schülerin oder Schüler / Gruppe</AnswerButton>
      <AnswerButton journey={'privatePerson'}>Private:r Erfinder:in mit Patent</AnswerButton>
    </div>
  </>);
}

export default StepKategorie;
